<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>His Leading Man</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Ashlyn Kane</p>
<p class="P_Normal"> </p>
<p class="P_Normal">He wrote a comedy. Fate directed a romance.</p>
<p class="P_Normal">Drew Beaumont is bored of the same old roles: action hero, supervillain, romantic lead. He’s not going to let a fresh gay buddy comedy languish just because they can’t find him the right costar. No, Drew bats his eyelashes and convinces everyone that the movie’s writer should play Drew’s not-so-straight man.</p>
<p class="P_Normal">Aspiring writer Steve Sopol has never had a screenplay optioned. Now one of Hollywood’s hottest properties wants to be in a movie Steve hasn’t finished writing—and he wants Steve as his costar. Turns out the chemistry between them is undeniable—on and offscreen.</p>
<p class="P_Normal">Drew swore off dating in the biz, but Steve is the whole package: sharp, funny, humble, and cute. For Steve, though, giving in to the movie magic means the end of the privacy he cherishes. Will the credits roll before their ride into the sunset?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?021851f4